import { Chip, Stack } from '@/design';
import type { ThreeDPerformanceSnapshot } from './model';

interface ThreeDPerformanceChipProps {
  snapshot: ThreeDPerformanceSnapshot;
  pointCloudMode?: boolean;
}

function fpsVariant(fps: number): 'success' | 'warning' | 'error' {
  if (fps >= 50) return 'success';
  if (fps >= 30) return 'warning';
  return 'error';
}

export function ThreeDPerformanceChip({
  snapshot,
  pointCloudMode = false,
}: ThreeDPerformanceChipProps) {
  const pointBudgetLabel = pointCloudMode
    ? `Point budget ${Math.round(snapshot.pointBudget).toLocaleString()}`
    : `LOD ${snapshot.lod}`;
  return (
    <Stack direction="row" align="center" gap={1} style={{ flexWrap: 'wrap' }}>
      <Chip
        icon="speed"
        label={`${snapshot.fps.toFixed(0)} FPS`}
        variant={fpsVariant(snapshot.fps)}
        aria-label={`${snapshot.fps.toFixed(0)} frames per second`}
      />
      <Chip icon="tune" label={pointBudgetLabel} variant="neutral" />
      <Chip
        icon="sync_problem"
        label={`Dropped ${Math.max(0, Math.round(snapshot.droppedFrames))}`}
        variant={snapshot.droppedFrames > 10 ? 'warning' : 'neutral'}
      />
    </Stack>
  );
}
